export default "__VITE_ASSET__CDm_CXpN__"